module.exports = __webpack_public_path__ + "img/drop_golden.3f686274.png";